import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';

interface MenuItem {
    label               : string;
    icon                : string;
    route               : string;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatListModule, RouterModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css'
})
export class Sidebar implements OnInit {
	rawMenuItems: MenuItem[] = [
		{ label: 'Liquidaciones', icon: 'receipt_long', route: '/liquidations' }
	];

	menuItems: MenuItem[] = [];

	ngOnInit(): void {
		this.menuItems = this.rawMenuItems;
	}
}
